import { LoadingSpinner, getApolloClient, SelectInput, useDebounce } from '@prenuvo/shared-library';
import React, { useMemo, useState } from 'react';
import { ApolloProvider, gql, useQuery } from '@apollo/client';
import styled from 'styled-components';

import { getPortalUrl } from 'packages/locations';

import { Column, Row } from '../Layout';
import { AmountToPay } from '../AmountToPay';

const PartnerRow = styled(Row)`
  display: grid;
  grid-template-columns: repeat(3, 33.3%);
`;

const PARTNER_LIST_QUERY = gql`
  query partners($search: String!) {
    partners(search: $search) {
      edges {
        node {
          id
          name
        }
      }
    }
  }
`;

const getPartnerSelectOptions = (data) => {
  const { partners } = data;
  const { edges } = partners;

  return edges.map(({ node }) => ({ label: node.name, value: node.id })).flat();
};

export const InvoicePayment = ({ transaction, setTransaction }) => {
  const [selectedPartnerOption, setSelectedPartnerOption] = useState();

  const { loading, error, refetch } = useQuery(PARTNER_LIST_QUERY, {
    skip: true,
  });

  if (loading || error) {
    return <LoadingSpinner size="small" />;
  }

  const getPartners = async (input) => {
    if (input && input.trim().length < 3) {
      return [];
    }

    const newPartners = await refetch({ search: input });
    return getPartnerSelectOptions(newPartners.data);
  };

  const loadPartners = useDebounce(getPartners);

  const handleChange = (selectedOption) => {
    setSelectedPartnerOption(selectedOption);
    const invoicePayer = selectedOption?.value;
    if (invoicePayer && invoicePayer !== transaction?.invoicePayer) {
      setTransaction({
        ...transaction,
        invoicePayer,
        status: 'pending',
      });
    }
  };

  return (
    <>
      <PartnerRow>
        <AmountToPay transaction={transaction} setTransaction={setTransaction} />
        <Column />
        <Column>
          <SelectInput
            placeholder="Search Partners"
            label="Search Partners"
            variant="primary"
            isAsync
            isClearable
            loadOptions={loadPartners}
            onChange={(selectedOption) => {
              handleChange(selectedOption);
            }}
            isMulti={false}
            disabled={false}
            value={selectedPartnerOption}
            showIndicatorAnimation={false}
          />
        </Column>
      </PartnerRow>
    </>
  );
};



const InvoicePaymentWithApollo = ({ transaction, setTransaction }) => {
  const [apiEndpoint] = useState(getPortalUrl());

  const apolloClient = getApolloClient(apiEndpoint);
  return useMemo(
    () => (
      <>
        {apiEndpoint && (
          <ApolloProvider client={apolloClient}>
            <InvoicePayment transaction={transaction} setTransaction={setTransaction} />
          </ApolloProvider>
        )}
      </>
    ),
    [transaction],
  );
};

export default InvoicePaymentWithApollo;
